var React = require('react');

function GhanaRound (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 0C27.9411 0 36 8.05873 36 18C36 27.9411 27.9411 36 18 36C8.05865 36 0 27.9411 0 18C0 8.05873 8.05865 0 18 0Z","fill":"#006B3F","key":0}),React.createElement("path",{"d":"M34.9748 23.9988H1.02515C0.361901 22.1223 0 20.1036 0 18C0 8.05873 8.05865 0 18 0C27.9411 0 36 8.05873 36 18C36 20.1036 35.6378 22.1223 34.9748 23.9988Z","fill":"#FCD116","key":1}),React.createElement("path",{"d":"M34.9193 11.8439H1.08069C3.59537 4.93454 10.221 0 18.0001 0C25.7788 0 32.405 4.93454 34.9193 11.8439Z","fill":"#CE1126","key":2}),React.createElement("path",{"d":"M17.9683 11.8439L21.9493 23.9988L11.6095 16.4865H24.3906L14.0507 23.9988L17.9683 11.8439Z","fill":"black","key":3})]);
}

GhanaRound.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = GhanaRound;

GhanaRound.default = GhanaRound;
